export default __webpack_public_path__ + "static/media/pinterest.5239636a.svg";